import React from 'react';
import classNames from 'classnames';

import styles from './TextInput.module.scss';

export const TextInput = ({
  name,
  label,
  type = 'text',
  shouldDisplayLabel = true,
  isRequired,
  leftIcon: LeftIcon,
  error,
  className,
  ...props
}) => (
  <div className={styles.container}>
    {shouldDisplayLabel && (
      <label htmlFor={name} className={styles.label}>
        {label} {isRequired && <span className={styles.required}>*</span>}
      </label>
    )}
    <div className={styles.inputContainer}>
      {LeftIcon && (
        <div className={styles.leftIcon}>
          <LeftIcon />
        </div>
      )}
      <input
        {...props}
        type={type}
        name={name}
        id={name}
        className={classNames(
          styles.input,
          {
            [styles.error]: error,
            [styles.withLeftIcon]: LeftIcon,
          },
          className
        )}
      />
    </div>
    {error && <div className={styles.errorMessage}>{error}</div>}
  </div>
);
